<div mat-dialog-title class="dialog-info">
  <label class="dialogTitle">{{'SEARCH_ESTIMATE' | translate}}</label>
  <button type="button" class="btn-close btn-close-white shadow-none dialogCross"
     [mat-dialog-close]></button>
</div>

<div class="dialog-wrapper">
  <mat-dialog-content class="open-estimate-dialog-content">
    <open-estimate [fromCreateOpportunity]="true" (selectedEstimateId)="closeDialog($event)" (cancel)="cancelDialog()"></open-estimate>
  </mat-dialog-content>
</div>

